<script setup lang="ts">
import { ThemeMode, useTheme } from "@/composable/useTheme";
import { trackAppSetting } from "@/analytics/app-analytics";

import SettingsOptionRow from "./SettingsOptionRow.vue";
const { theme, setTheme } = useTheme();

// Tracked here, not in useTheme: it replays the stored mode at boot.
function onThemePicked(mode: ThemeMode) {
  trackAppSetting("theme_mode", mode);
  setTheme(mode);
}

const options = [ThemeMode.SYSTEM, ThemeMode.DARK, ThemeMode.LIGHT];
</script>
<template>
  <SettingsOptionRow
    :label="$t('dashboard:settings.theme.title')"
    icon="bi-palette"
  >
    <el-button-group class="ml-4">
      <el-button
        v-for="option in options"
        :key="option"
        :type="theme === option ? 'primary' : 'default'"
        @click="onThemePicked(option)"
        >{{ $t(`dashboard:settings.theme.option.${option}`) }}</el-button
      >
    </el-button-group>
  </SettingsOptionRow>
</template>
